import { useMutation } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

const publishEvents = async (uuids: string[]) => {
  const response = await CustomAxios.post('events/publish', { uuids });
  return response.data;
};

export function usePublishEvents() {
  return useMutation({
    mutationFn: publishEvents,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.allEvents] });
    },
  });
}
